// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ProjectExtended } from '../../../assets/icons/extended/entities/project.svg?react';
import { createIcons } from '../../Icon';
const ProjectIcon = /* @__PURE__ */ createIcons('Project', {
    extended: ProjectExtended
});
ProjectIcon.supportedTypes = ['extended'];
ProjectIcon.category = 'entities';
export default ProjectIcon;
